import React from "react";

import "./nextDayStayTuned.css";

const NextDayStayTuned = (prop) => {
  return (
    <div className="nextDayStayTuned">
      <div className="nextDayStayTuned-wrapper">
        <h3 className="title">Stay Tuned</h3>
        <p className="info">Questions will be updated soon!</p>
      </div>
    </div>
  );
};

export default NextDayStayTuned;
